import React, {useEffect} from 'react';
import {Text} from '@gravity-ui/uikit';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {SelectCategoryGroups} from '../../../../entities';
import {useMoveCategoryForm} from '../../model';
import styles from './MoveCategoryModal.module.scss';

interface MoveCategoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  categoryId: string | null;
  currentGroupId?: string | null;
}

export const MoveCategoryModal = ({open, setOpen, categoryId, currentGroupId}: MoveCategoryModalProps) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    isLoading,
    submitError,
    resetForm,
    submitForm,
  } = useMoveCategoryForm({setOpen, categoryId, initialGroupId: currentGroupId ?? null});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Перемещение категории',
    title: 'Ошибка при перемещении категории',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  const handleGroupChange = (value: string[]) => {
    setFieldValue('newGroupId', value[0] || '');
    setFieldTouched('newGroupId', true, false);
  };

  const selectedValue = values.newGroupId ? [values.newGroupId] : [];

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Переместить категорию'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <div className={styles.fieldContainer}>
          <Text variant="subheader-1" className={styles.label}>
            Название группы
          </Text>
          <SelectCategoryGroups
            value={selectedValue}
            onUpdate={handleGroupChange}
            name="newGroupId"
            size="l"
            placeholder="Выберите группу"
            error={touched.newGroupId && errors.newGroupId}
          />
        </div>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
